// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue             from 'vue'
import lodash          from 'lodash'

import notLoggedApp    from './Not_Logged_App'
import adminApp        from './Admin_App'

import notLoggedRouter from './router/not_logged'
import adminRouter     from './router/admin'

Vue.config.productionTip = false

Vue.filter('twoDecimals', function (value) {
  return value.toFixed(2);
});

/* eslint-disable no-new */
var token = localStorage.getItem('token')

window._ = lodash

if (token) {
  new Vue({
    el: '#app',
    router: adminRouter,
    template: '<adminApp/>',
    components: { adminApp }
  })
} else {
  new Vue({
    el: '#app',
    router: notLoggedRouter,
    template: '<notLoggedApp/>',
    components: { notLoggedApp }
  })
}



// WEBPACK FOOTER //
// ./src/main.js